import { useEffect, useRef, useState } from "react";
import HC from "@/lib/compute";

const MESSAGE = "The Study Closure Form has not been approved.";

export function isClosureApproved(p) {
  if (!p) return true;
  const closed = (HC.M && HC.M.data && HC.M.data.closed) || [];
  return closed.includes(p);
}

export function ClosureGate({ p, onPickAnother }) {
  const [open, setOpen] = useState(true);
  const seen = useRef("");

  useEffect(() => {
    if (p && seen.current !== p) {
      seen.current = p;
      setOpen(true);
    }
  }, [p]);

  const close = () => setOpen(false);

  return (
    <>
      <div className="card span-12" role="status" data-testid="closure-gate-card">
        <div className="card-head">
          <div>
            <h2>Project score hidden</h2>
            <p className="sub">
              {MESSAGE} The project score for <b>{p}</b> will be shown once the research agency
              submits and the reviewer approves the Study Closure Form.
            </p>
          </div>
        </div>
        <div className="hnote warn" style={{ marginTop: 0 }}>
          Need to pick a different project? Use the <b>Project</b> dropdown above, or clear the
          selection with <b>Reset</b> to see the agency-level or overall averages.
        </div>
        {onPickAnother ? (
          <div style={{ marginTop: "12px" }}>
            <button
              className="btn"
              type="button"
              data-testid="closure-gate-reset"
              onClick={onPickAnother}
            >
              Clear project selection
            </button>
          </div>
        ) : null}
      </div>

      {open ? (
        <div
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="closure-dialog-title"
          data-testid="closure-gate-dialog"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(13, 26, 58, 0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            zIndex: 60,
          }}
          onClick={close}
        >
          <div
            className="card"
            style={{ maxWidth: "440px", width: "100%" }}
            onClick={e => e.stopPropagation()}
          >
            <h2 id="closure-dialog-title" style={{ marginBottom: "6px" }}>Score unavailable</h2>
            <p className="sub">{MESSAGE}</p>
            <p className="sub" style={{ marginTop: "8px" }}>
              The project score for <b>{p}</b> will appear once the Study Closure Form is approved.
              Until then, pick another project or reset the filters.
            </p>
            <div style={{ marginTop: "14px", display: "flex", justifyContent: "flex-end", gap: "8px" }}>
              <button
                className="btn"
                type="button"
                data-testid="closure-gate-dialog-ok"
                onClick={close}
                autoFocus
              >
                OK
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
